/**
 * The react-query cache key every reader of "the owner's schedules" must use.
 *
 * Moved out of `useSchedules.js` into a module of its own (spec 152), which re-exports
 * it so every existing import keeps working. The reason is the same one that put it in
 * `useSchedules.js` rather than in `reportScheduleService` in the first place: suites
 * mock modules wholesale, and a key imported from a mocked module comes back missing.
 * Six suites mock `@hooks/useSchedules` with factories that define only the hooks they
 * need, and they render the queue modal — whose retention sentence now reads the cached
 * list through `useResultMaxAgeDays`. Nothing mocks this file.
 */
export const SCHEDULES_QUERY_KEY = ['report-schedules']
